import { Award, Thermometer } from "lucide-react";

export const AboutCompany = () => {
  return (
    <section id="about-company" className="py-24 sm:py-32">
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="border border-slate-200 overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/2szfcyc5_About%20Me.jpeg"
                  alt="Kamran Qureshi, founder of ZID IT Solutions"
                  className="w-full h-[520px] object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 hidden sm:block">
                <div className="font-heading font-black text-3xl">12+</div>
                <div className="text-sm text-blue-100 mt-1">Years in IT</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">Who We Are</span>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-slate-950 mt-4">
              About Me
            </h2>
            <div className="mt-6 space-y-5 text-lg text-slate-600 leading-relaxed">
              <p>
                I'm <span className="font-semibold text-slate-950">Kamran Qureshi</span>, the founder of ZID IT
                Solutions, with over 12 years of experience in the IT industry, specializing in application support,
                user device management, network troubleshooting, and technical solutions. I have a strong track record
                of resolving complex technology issues, supporting end users, and ensuring the smooth operation of
                business-critical systems.
              </p>
              <p>
                My expertise includes improving system performance, enhancing user experiences, managing IT
                environments, and delivering reliable solutions for both businesses and residential customers. I'm
                passionate about technology, problem-solving, and helping clients use their systems more efficiently
                and securely.
              </p>
              <p className="flex gap-3 items-start bg-slate-50 border border-slate-200 p-5">
                <Thermometer size={22} className="text-blue-600 flex-shrink-0 mt-1" />
                <span>
                  Along with my IT expertise, I also hold an <span className="font-semibold text-slate-950">HVAC
                  license</span>, allowing me to provide professional smart home solutions, including smart thermostat
                  installation and integration with HVAC systems.
                </span>
              </p>
              <p className="text-slate-950 font-medium">
                Known for my logical thinking, attention to detail, and ability to collaborate with clients and teams,
                my goal is to provide dependable technology solutions that make everyday life and business operations
                easier.
              </p>
            </div>
            <div className="mt-8 inline-flex items-center gap-3 border border-slate-200 px-5 py-4">
              <Award size={22} className="text-blue-600" />
              <span className="text-sm font-semibold text-slate-950">Licensed IT Professional & HVAC Technician</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
